export const GUITAR_TUNINGS = [
  {
    name: "6 String - Standard",
    notes: ["E", "B", "G", "D", "A", "E"],
  },
  {
    name: "6 String - Drop D",
    notes: ["E", "B", "G", "D", "A", "D"],
  },
  {
    name: "6 String - Drop C#",
    notes: ["D#", "A#", "F#", "C#", "G#", "C#"],
  },
  {
    name: "6 String - Drop C",
    notes: ["D", "A", "F", "C", "G", "C"],
  },
  {
    name: "7 String - Standard",
    notes: ["E", "B", "G", "D", "A", "E", "B"],
  },
  {
    name: "7 String - Drop A",
    notes: ["E", "B", "G", "D", "A", "E", "A"],
  },
  {
    name: "7 String - Drop F#",
    notes: ["C#", "G#", "E", "B", "F#", "C#", "F#"],
  },
];
